<template>
  <div class="appAside">
    <el-menu unique-opened
             :default-active="activeIndex"
             background-color="#36373c" text-color="#fff" active-text-color="#ff0">
      <template v-for="(menu, i) in menus">
        <el-submenu :key="i" :index="menu.path" v-if="!menu.hidden && menu.children && menu.children.length > 0">
          <template slot="title">
            <!--            <i class="icon iconfont imgIcon" :class="'icon-' + menu.meta.icon"></i>-->
            <span slot="title">{{menu.meta.title}}</span>
          </template>
          <template v-for="(child, j) in menu.children">
            <router-link :key="j" v-if="!child.hidden" :to="menu.path + '/' + child.path" class="link">
              <el-menu-item :index="menu.path + '/' + child.path">
                <span>{{child.meta.title}}</span>
              </el-menu-item>
            </router-link>
          </template>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
  import { pageRouter } from '@/router';
  import { isNumber } from '@/utils/validate';
  
  export default {
    name: 'AppAside',
    data () {
      return {
        menus: pageRouter
      };
    },
    computed: {
      activeIndex () {
        const paths = this.$route.path.split('/');
        const pathsLastParmas = paths[paths.length - 1];
        
        if (pathsLastParmas === 'new' || isNumber(pathsLastParmas)) {
          paths.pop();
          return paths.join('/');
        }
        
        return this.$route.path;
      }
    }
  };
</script>

<style lang="scss">
  .appAside {
    a {
      text-decoration: none !important;
    }
    
    .link {
      display: block;
    }
    
    .el-menu {
      border-right: none !important;
    }
    
    .imgIcon {
      vertical-align: middle;
      margin-right: 5px;
      width: 25px;
      height: 25px;
    }
    
    .el-menu-item {
      height: 45px !important;
      line-height: 45px !important;
    }
    
    .el-menu--inline {
      .el-menu-item {
        font-size: 12px;
        padding-left: 50px !important;
        min-width: auto !important;
        width: 100% !important;
      }
    }
    
    .el-submenu__title:hover,
    .el-menu-item:hover {
      background: rgba(102, 102, 102, 0.5) !important;
    }
  }
</style>
